import { get } from 'lodash'
import { createSelector } from 'reselect'
import * as Exp from '../experimentConstants'

const getSelectedApplicationCountry = state => state.selectedApplicationCountry

const getExperiments = state => state.experiments

export const getBGCFormExperiment = createSelector(
  getSelectedApplicationCountry,
  getExperiments,
  (selectedApplicationCountry, experiments) => {
    if (
      get(experiments, `${Exp.BGC_UPDATE_FORM_VALIDATION}`, false) &&
      !selectedApplicationCountry.isJP
    ) {
      return true
    }

    return false
  }
)
